import { GraphQL } from "@rpi/openapi-api";

export const fmtDashboardUserName = (
  user?: Pick<GraphQL.DashboardUserResponse, "firstName" | "lastName" | "username">
) => {
  if (!user) return "";
  if (!user.firstName && !user.lastName) return user.username;
  return [user.firstName, user.lastName, `(${user.username})`].join(" ");
};
